import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'

import reportsServices from '../reportsServices';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import PendingCounterByType from '../components/PendingCounterByType';
import SupervisorPendingCounter from '../components/SupervisorPendingCounter';

function SupervisorPendingReportPage() {

    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
    const [reportData,setReportData] = useState(null);
    const [assignedGrievanceType,setAssignedGrievanceType] = useState(null);


    const getPendingReport = () => {
        reportsServices.getSuperVisorPending().then(res=>{
            setReportData(res.data.grievanceList);
            setAssignedGrievanceType(res.data.assignedGrievanceType)
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getPendingReport()
    },[])

    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row mb-3'>
                    <div className='col-md-12'>
                        <div class="p-2 bg-dark text-center text-white rounded">
                            <h3 className='mb-0' >Total Pandency</h3>
                        </div>
                    </div>
                </div>
                {reportData && assignedGrievanceType && masters && <SupervisorPendingCounter reportData={reportData} assignedGrievanceType={assignedGrievanceType.split(",").map(Number)} masters={masters} getMasterLabel={getMasterLabel} /> }
            </div>
        </AppLayout>
    )
}

export default SupervisorPendingReportPage